import gql from 'graphql-tag';

export const CREATE_VARIATION_GROUP = gql`
  mutation createVariationGroup($data: VariationGroupCreateInput!) {
    node: createVariationGroup(data: $data) {
      id
      title {
        id
        se
        en
        es
        no
      }
    }
  }
`;
export const CREATE_MENU = gql`
  mutation createMenu($data: MenuCreateInput!) {
    node: createMenu(data: $data) {
      id
    }
  }
`;

export const COMPANY_QUERY = gql`
  query getCompany($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      name

      hasPOS
      hasTables
      hasAppOrders
      hasKDS
      hasExpress
      hasInventory
      manualEndOfDay

      venues {
        id
        name
      }

      languages
      defaultLanguage

      categories(filter: { deleted: false, company: { id: $companyId } }) {
        parentId
        id
        name
        vatRate
        courseType {
          id
        }
        nameLang {
          id
          se
          en
          es
          no
        }
        order
      }

      menus {
        id
        name
        deleted
      }

      upsells {
        id
        displayOrder
        name {
          id
          en
          se
          es
          no
        }
        items {
          id
          title
        }
      }

      courseTypes {
        id
        label
        name
      }

      variationGroups {
        id
        title {
          id
          se
          en
          es
          no
        }
        required
        variationClass
        type
        variations {
          id
          name
          allergen
          price
        }
      }

      variations {
        id
        name
        price
        allergen
        group {
          id
          variationClass
        }
      }
    }
  }
`;

export const ITEMS_QUERY = gql`
  query getItems($companyId: String!) {
    getItems(companyId: $companyId) {
      count
      results {
        id
        title
        titleLang {
          id
          se
          en
          es
          no
        }
        vatRate
        defaultPrice
        order
        categories {
          id
          name
        }
        courseType {
          id
          label
        }
        description
        descriptionLang {
          id
          se
          en
          es
          no
        }
        menus {
          menuId
          price
          menuEntryId
        }
      }
    }
  }
`;

export const PIM_QUERY = gql`
  query getPimData($stringId: String!, $id: ID!, $first: Int, $skip: Int) {
    items: getItems(companyId: $stringId, first: $first, skip: $skip) {
      count
      results {
        id
        title
        titleLang {
          id
          se
          en
          es
          no
        }
        vatRate
        defaultPrice
        order
        categories {
          id
          name
        }
        courseType {
          id
          label
        }
        description
        descriptionLang {
          id
          se
          en
          es
          no
        }
        menus {
          menuId
          price
          menuEntryId
        }
      }
    }

    company: Company(id: $id) {
      id
      name

      hasPOS
      hasTables
      hasAppOrders
      hasKDS
      hasExpress
      hasInventory
      manualEndOfDay

      venues {
        id
        name
      }

      languages
      defaultLanguage
      defaultCurrency

      categories(filter: { deleted: false, company: { id: $id } }) {
        parentId
        id
        name
        vatRate
        courseType {
          id
        }
        nameLang {
          id
          se
          en
          es
          no
        }
        order
      }

      menus {
        id
        name
        deleted
      }

      upsells {
        id
        name {
          id
          en
          se
          es
          no
        }
        items {
          id
          title
        }
        displayOrder
      }

      courseTypes {
        id
        label
        name
        order
      }

      variationGroups {
        id
        title {
          id
          se
          en
          es
          no
        }
        required
        variationClass
        type
        variations {
          id
          name
          allergen
          price
        }
      }

      variations {
        id
        name
        price
        allergen
        group {
          id
          variationClass
        }
        order
      }

      modificationGroups {
        id
        type
        internalName
        externalName
        preselectedVariations
        variations {
          id
          name
        }
        required
        expandedByDefault
      }
    }
  }
`;
